if (!customElements.get('sleepdoctor-impact-stats')) {
  class SleepdoctorImpactStats extends HTMLElement {
    constructor () {
      super()
      this.counters = []
      this.animated = false
      this.observer = null
    }

    connectedCallback () {
      this.counters = this.querySelectorAll('[data-target]')
      this.setupIntersectionObserver()
    }

    disconnectedCallback () {
      if (this.observer) {
        this.observer.disconnect()
      }
    }

    setupIntersectionObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true
            this.animateCounters()
          }
        })
      }, options)

      this.observer.observe(this)
    }

    animateCounters () {
      const duration = 2000

      this.counters.forEach((counter) => {
        const targetValue = parseInt(counter.dataset.target, 10)
        const valueElement = counter.querySelector('.sleepdoctor-impact-stats__number-value')

        if (!valueElement || isNaN(targetValue)) return

        const startTime = performance.now()

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime
          const progress = Math.min(elapsed / duration, 1)

          const easing = 1 - Math.pow(1 - progress, 3)
          const currentValue = Math.floor(targetValue * easing)

          valueElement.textContent = currentValue.toLocaleString()

          if (progress < 1) {
            requestAnimationFrame(animate)
          } else {
            valueElement.textContent = targetValue.toLocaleString()
          }
        }

        requestAnimationFrame(animate)
      })
    }
  }

  customElements.define('sleepdoctor-impact-stats', SleepdoctorImpactStats)
}
